import Base from './Base';

export default class Catalog extends Base {
  constructor(props, children = []) {
    super();
    this.import(props, children);
  }

  import(props) {
    this.id = this.assign('id', props);
    this.itemId = this.assign('itemId', props);
    this.type = this.assign('type', props);
    this.name = this.assign('name', props);
    this.description = this.assign('description', props);
    this.thumbnail = this.assign('thumbnail', props);
    this.source = this.assign('source', props);
    this.gtin = this.assign('gtin', props);
    this.category = this.assign('category', props);
    this.rawData = this.assign('rawData', props);
    this.checksum = this.assign('checksum', props);
    this.images = this.assign('images', props) || [];
    this.createdAt = this.assign('createdAt', props);
    this.updatedAt = this.assign('updatedAt', props);
  }

  export() {
    return {
      id: this.id,
      itemId: this.itemId,
      type: this.type,
      name: this.name,
      description: this.description,
      thumbnail: this.thumbnail,
      source: this.source,
      gtin: this.gtin,
      category: this.category,
      rawData: this.rawData,
      checksum: this.checksum,
      images: this.images,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }
}
